<smt-modal [(isActive)]="confirmModalActive"  [allowDropDownOverflow]="true" [disableFooter]="false" [disableHeader]="true"
    (acceptEvent)="removeMeasure()" (rejectEvent)="confirmModalActive = false"
    acceptText="Remove" acceptCssClass="button primary" rejectText="Cancel" rejectCssClass="button cancel">
   <div role="body">
        Please confirm permanent removal of record.
   </div>
</smt-modal>
<smt-modal [(isActive)]="costCenterListModalActive"  [allowDropDownOverflow]="false" [disableFooter]="false" [disableHeader]="false"
    (acceptEvent)="costCenterListModalActive = false" (rejectEvent)="costCenterListModalActive = false"  
    acceptText="Ok" acceptCssClass="button primary"  rejectCssClass="button cancel">
    <div role="header">Cost Centers associated to {{measureName}}</div>
   <div role="body">
        <table class="condensed">
            <thead>
              <tr><th>Cost Center Name</th></tr>
            </thead>
            <tbody>
              <tr *ngFor="let costCenterName of costCenterNames"><td>{{costCenterName}}</td></tr>
            </tbody>
        </table>
   </div>
</smt-modal> 
<div class="page-header-outer">
  <div class="page-header">
      <h1>Measures</h1>
      <div class="controls">
            <button [disabled]="!addButtonEnabled" (click)="onAddMeasureClick()"><span class="icon-plus"></span> Add New</button>
      </div>
  </div>
</div>
<div class="content-inner">
    <div class="admin-main" [ngClass]="{'loading': initialLoading || mobileLoading }" >
        <div>
            <div class="admin-list" [ngClass]="{'loading': adminListLoading }"
                infinite-scroll
                [infiniteScrollDistance]="scrollDistance"
                [infiniteScrollThrottle]="scrollThrottle"
                [fromRoot]="false"
                [scrollWindow]="false"
                [infiniteScrollContainer]="scrollSelector"
                (scrolled)="onScrollDown()">
                <div class="filter-sort">
                    <div class="filter">
                        <input class="compact magic-filter" (keyup)="onSearchKey($event)" [(ngModel)]="searchText" name="SearchKey" type="text" placeholder="Search by Measure">
                    </div>
                    <div class="sort">
                        <label class="compact">Sort</label>
                        <select class="compact" (change)="onSortTypesDropDownChanged($event)" [(ngModel)]="selectedFilter" name="SortList">
                            <option *ngFor='let type of sortTypes' [value]="type" (change)="setSelectedFilter($event)">
                                {{type}}
                            </option>
                        </select>
                        <a class="arrow compact" (click)="onChangeSortOrder()"
                            [ngClass]="sortAscending ? 'icon-arrow-up-bold' : 'icon-arrow-down-bold'"></a>
                    </div>
                </div>
                <ul class="adminListScroll" >
                    <li *ngFor="let measure of measures" [value]="measures.Id" (click)="onSelection(measure)"
                        [ngClass]="{'active': selection != undefined && selection != null && measure.id == selection.id } ">
                        <ul class="added">
                                <li class="active">
                                    <div *ngIf="measure.mostRecent">
                                        <span class="icon-plus"></span> New
                                    </div>
                                </li>
                        </ul>
                        <div id="measuretitle" class="title">{{measure.factor }}</div>
                        <ul class="details">
                            <li class="modified">
                                        <span class="label">Description</span>
                                        <span class="value">{{ measure.description }}</span>
                            </li>
                            <li class="modified">
                                <span class="label">Code</span>
                                <span class="value">{{ measure.code }} </span>
                            </li>
                            <li class="modified">
                                <span class="label">Last Modified</span>
                                <span class="value">{{ measure.modifiedDate == null ? "&nbsp;" : ( measure.modifiedDate + "Z" | date: 'M/dd/yy h:mm a') }}</span>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div class="admin-action-window" [ngClass]="{ 'loading': adminActionLoading }">
                <div class="admin-action suppress-scroll" id="edit" [ngClass]="{ 'active': showAdminActionWindow }" *ngIf="selection">
                    <div class="header">
                        <div class="title">
                            {{ adminActionLabelText }}
                            <button class="primary compact" [disabled]="!deleteButtonEnabled" (click)="confirmModalActive = true"><span class="icon-trash btn-Icon"></span>{{ adminActionButton1LabelText }}</button>
                            <a class="close" href="javascript:void(0)" (click)="onCancel()"><span class="icon-cross"></span></a>
                        </div>
                    </div>
                    <div>
                        <form #measureEditForm="ngForm" (ngSubmit)="onSave()">
                            <section>
                              <div class="body">
                                <div class="form-group">
                                  <label>Measure</label>
                                  <input maxlength="25" type="text" required name="Measure" [readonly]="readOnly" [(ngModel)]="selectedMeasure">
                                </div>
                                <div class="form-group">
                                  <label>Code</label>
                                  <input maxlength="25"type="text" required name="Code" [readonly]="readOnly" [(ngModel)]="selectedCode">
                                </div>
                                <div class="form-group">
                                  <label>Description</label>
                                  <input maxlength="255" type="text" required name="Description" [readonly]="readOnly" [(ngModel)]="selectedDescription">
                                </div>
                                <div class="form-group">
                                  <label>Display Units</label>
                                  <input maxlength="25" type="text" name="DisplayUnits" [readonly]="readOnly" [(ngModel)]="selectedDisplayUnits" pattern="^([A-Za-z0-9]+[\s]*)+$">
                                </div>
                                <div class="form-group">
                                  <label>Calculation</label>
                                  <ul class="options">
                                    <li>
                                      <label>
                                        <input type="radio" name="hasTotalCalculation" [value]="true" [(ngModel)]="hasTotalCalculation" required>Total
                                      </label>
                                    </li>
                                    <li>
                                      <label>
                                        <input type="radio" name="hasTotalCalculation" [value]="false" [(ngModel)]="hasTotalCalculation">Average
                                      </label>
                                    </li>
                                  </ul>
                                  <div class="form-group" [hidden]="!readOnly">
                                    <label>Calculation</label>
                                    <input type="text" name="hasCalculationReadonly" [readonly]="true" [value]="hasTotalCalculation ? 'Total' : 'Average'">
                                  </div>
                                    <span class="inline warning" *ngIf="showCostCenterWarning" >
                                      <span class="icon-warning2">
                                      </span> This measure is associated to one or more cost centers.<a class="warning" (click)="getCostCentersByMeasureId(true)"> Click here for more details.</a>
                                    </span>
                                </div>
                              </div>
                                <div class="footer">
                                    <div>
                                        <label class="errormsg">{{ getErrorMessage() }}</label>
                                    </div>
                                    <button class="primary" type="submit" [disabled]="!measureEditForm.form.valid || !measureEditForm.dirty || !saveButtonEnabled">
                                        <span class="icon-plus"></span> Save</button>
                                    <button class="cancel" type="button" (click)="onCancel()" [disabled]="saveLoading">
                                        <span class="icon-cancel"></span> Cancel</button>
                                </div>
                            </section>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
